import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * 当前登录的前台用户（Member）信息。
 */
export interface MemberInfo {
  id: number
  phone?: string
  nickname?: string
  avatar?: string
  userType?: number
  openid?: string
  [key: string]: unknown
}

function safeParseMemberInfo(): MemberInfo | null {
  try {
    return JSON.parse(localStorage.getItem('member_info') || 'null')
  } catch {
    console.warn('[member store] Failed to parse member_info from localStorage, resetting')
    localStorage.removeItem('member_info')
    return null
  }
}

export const useMemberStore = defineStore('member', () => {
  // 使用不同的 localStorage key，防止和后台 admin 的 token 冲突
  const token = ref(localStorage.getItem('member_token') || '')
  const memberInfo = ref<MemberInfo | null>(safeParseMemberInfo())

  const setToken = (newToken: string) => {
    token.value = newToken
    localStorage.setItem('member_token', newToken)
  }

  const setMemberInfo = (info: MemberInfo | null) => {
    memberInfo.value = info
    if (info) {
      localStorage.setItem('member_info', JSON.stringify(info))
    } else {
      localStorage.removeItem('member_info')
    }
  }

  const logout = () => {
    token.value = ''
    memberInfo.value = null
    localStorage.removeItem('member_token')
    localStorage.removeItem('member_info')
  }

  return {
    token,
    memberInfo,
    setToken,
    setMemberInfo,
    logout
  }
})
